import { render, staticRenderFns } from "./NuovaAttivita.vue?vue&type=template&id=78b438bf&"
import script from "./NuovaAttivita.vue?vue&type=script&lang=js&"
export * from "./NuovaAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports